<template>
  <div id="app">

    <navegationMenu />

    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <div id="takemeup" @click="goTop"><i class="icofont-simple-up"></i></div>
    <Footer />

  </div>
</template>

<script>
import navegationMenu from './components/navegationMenu.vue';
import loadErr from "./assets/status/0.png";
import Footer from './components/Small/Footer.vue';

export default {
  name: "App",
  data() {
    return {
    }
  },
  beforeMount() {
    this.client();
  },
  mounted() {
    //CATCHES ALL ERRORS FROM IMAGES AND SETS A DEFAULT IMAGE
    document.addEventListener('error', (e) => {
      if (!e.target) {
        return;
      }

      const errorTarget = e.target
      const imageErrorSource = errorTarget instanceof HTMLImageElement

      if (!imageErrorSource) return;

      errorTarget.src = loadErr;;
    }, true);

  },
  components: {
    navegationMenu,
    Footer
  },
  methods: {
    goTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Carme&display=swap");

* {
  text-decoration: none;
  padding: 0;
  margin: 0;
  font-family: "Carme";
  letter-spacing: 1px;
}

:root {
  color-scheme: dark;
}

body {
  transition: .4s;
}

#app {
  text-align: center;
  margin: 0 auto;
  min-height: 100vh;
  transition: .4s;
}

h1 {
  font-size: 50px;
}

h1, h2, h3, p {
  cursor: default;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.7s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.spinerParent {
  width: 100%;
  display: flex;

  justify-content: center;
  align-items: center;

  overflow: hidden;
}

.spinerParent img {
  height: 5vh;
  width: 5vh;
  animation: 1.3s rotate360 infinite linear;
}

.carousel-3d-container .carousel-3d-controls a span {
  font-family: "IcoFont" !important;
  font-size: 100px;
}

#Experience .carousel-3d-container .carousel-3d-controls a span {
  color: rgb(0, 0, 0);
}


@keyframes rotate360 {
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate360 {
  to {
    transform: rotate(360deg);
  }
}

#takemeup {
  position: fixed;

  height: 5.345vh;
  width: 5.345vh;
  min-height: 50px;
  min-width: 50px;

  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;

  top: calc(92vh - 25px);
  left: calc(92vw - 25px);

  font-size: 2.5em;
  border-radius: 50%;

  cursor: pointer;
  font-family: serif;

  transition: 0.5s;
  visibility: hidden;
  opacity: 0;
  z-index: 10;

  i {
    color: #fff;
  }
}


@media screen and (max-width: 500px) {
  #takemeup {
    top: calc(92vh - 25px);
    left: calc(90vw - 25px);
    transition: 0.5s;
    visibility: hidden;
    opacity: 0;
    height: 1.5em;
    width: 1.5em;
    font-size: 1.8em;
  }
}

@media screen and (max-width: 375px) {
  #takemeup {
    top: calc(92vh - 25px);
    left: calc(88vw - 25px);
    transition: 0.5s;
    visibility: hidden;
    opacity: 0;
    height: 1.8em;
    width: 1.8em;
    font-size: 1.5em;
  }
}

@media (prefers-color-scheme: dark) {
  body {
    background: #000 !important;
  }

  #app {
    background: #000 !important;
  }

  #takemeup {
    background: #fff;
    i {
      color: #000;
    }
  }
}

@media (prefers-color-scheme: light) {
  body {
    background-color: #fff;
  }

  #app {
    background: #fff !important;
  }

  #takemeup {
    background: #000;
    i {
      color: #fff;
    }
  }
}

</style>
